export default __webpack_public_path__ + "static/media/sasaki_logo_RGB-05.84e4722f.png";